var _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _line4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThemeTargetIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10,
    stroke: "#263145",
    strokeWidth: 2,
    fill: "none"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 7,
    stroke: "#006c67",
    strokeWidth: 1.5,
    fill: "none",
    opacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4,
    stroke: "#417bf6",
    strokeWidth: 1,
    fill: "none",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2,
    fill: "#263145"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 2,
    x2: 12,
    y2: 5,
    stroke: "#006c67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 19,
    x2: 12,
    y2: 22,
    stroke: "#006c67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 12,
    x2: 5,
    y2: 12,
    stroke: "#006c67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: 12,
    x2: 22,
    y2: 12,
    stroke: "#006c67",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThemeTargetIcon);
export default __webpack_public_path__ + "static/media/theme-target-icon.b77a0d8a9c15eb96fcd5aa159b93f45c.svg";
export { ForwardRef as ReactComponent };